var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dashboard__listing-desktop"},[_c('div',{staticClass:"dashboard__payment-history-wrap dashboard__overview-table"},[_c('table',{staticClass:"dashboard__payment-history-table"},[_vm._t("head"),_vm._v(" "),_vm._t("body")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b29306c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/resuables/table.vue
// module id = null
// module chunks = 